module.exports = __webpack_public_path__ + "static/img/8.7c2d336.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/8.png
// module id = dpIp
// module chunks = 0